export const CSS_CLASSES = {
	KEY: 'icon-key__list__key',
	ROOT: 'icon-key',
};
